<div class="client-summary-title">
  <a matButton="filled" [routerLink]="`/main`">
    <mat-icon>chevron_left</mat-icon>
    {{'buttons.back' | translate}}
  </a>
  <h3>{{'client.title' | translate}}</h3>
</div>

<div class="container">
  @if(!client){
  <div><code>Loading ...</code></div>
  }
  @else {
  <div class="column-1">
    <h1>{{client.firstName}}<br /> {{client.lastName}}</h1>
    <a matFab="outlined" extended [routerLink]="`/main/client/profile/${client.clientId}`">
      <mat-icon>person_pin</mat-icon>
      {{'client.view-profile' | translate}}
    </a>
  </div>
  <div class="column-2">
    <div><strong>{{'client.information.date-of-birth' | translate}}</strong> {{client.dateOfBirth | date:'MMMM dd, yyyy'}}</div>
    <div><strong>{{'client.information.age' | translate}}</strong> {{client.age }}</div>
    <div><strong>{{'client.information.contact-phone' | translate}}</strong> {{client.phoneNumber || 'Not provided'}}</div>
    <div><strong>{{'client.information.assign-to' | translate}}</strong> {{client.assignTo}}</div>
    <div><strong>{{'client.information.id' | translate}}</strong> {{client.clientId}}</div>
    <div>
      <a matButton>
        <mat-icon>person_alert</mat-icon>
        {{'client.information.re-assign-client' | translate}}
      </a>
    </div>
    <div>
      <a matButton>
        <mat-icon>person</mat-icon>
        {{'client.information.alternative-id' | translate}}
      </a>
    </div>
  </div>
  <div class="column-3">
    <mat-card appearance="outlined" class="client-summary-info-card">
      <mat-card-content>
        <div>
          <div><strong>{{'client.information.status' | translate}}</strong> {{client.activeStatus || '--Not provided --'}}</div>
          <div><strong>{{'client.information.type' | translate}}</strong> {{client.type || '--Not provided --'}}</div>
          <div><strong>{{'client.information.coordinator' | translate}}</strong> {{client.assignTo}}</div>
          <div><strong>{{'client.information.funder' | translate}}</strong> {{client.funder || '--Not provided --'}}</div>
          <div><strong>{{'client.information.obu' | translate}}</strong> {{client.obu || '--Not provided --'}}</div>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div>
          <div><strong>{{'client.information.enroll-status' | translate}}</strong> {{client.enroll || '--Not provided --'}}</div>
          <div><strong>{{'client.information.enroll-date' | translate}}</strong> {{client.enrollDate | date:'MMMM dd, yyyy'}}</div>
          <div><strong>{{'client.information.program' | translate}}</strong> {{client.program || '--Not provided --'}}</div>
          <div><strong>{{'client.information.medical-record-number' | translate}}</strong> {{client.mrn || '--Not provided --'}}</div>
          <div><strong>{{'client.information.roi-status' | translate}}</strong> {{client.roi || '--Not provided --'}}</div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  }
</div>

<div>
  @if(!client){
  <div><code>Loading ...</code></div>
  }
  @else{
  <app-vertical-tabs [clientId]="clientId!"></app-vertical-tabs>
  }
</div>
